export var autoBot = function () { return ({
    toFirestore: function (data) { return data; },
    fromFirestore: function (snap) {
        return snap.data();
    }
}); };
